// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
// tslint:disable:max-line-length
import { registerIcons } from '@uifabric/styling';
var initializedIcons = false;
// Update the hashes here when adding/removing icons
var fabricFontFile = 'officestarticons-6114ff7c.woff';
var fluentFontFile = 'officestarticons-fluent-a4b37e10.woff';
export function initializeIcons(baseUrl, useFluentFont) {
    if (useFluentFont === void 0) { useFluentFont = false; }
    if (initializedIcons) {
        return;
    }
    initializedIcons = true;
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none',
        },
        fontFace: {
            fontFamily: 'FabricMDL2Icons',
            src: "url('" + baseUrl + (useFluentFont ? fluentFontFile : fabricFontFile) + "') format('woff')",
        },
        icons: {
            Accounts: '\uE910',
            Add: '\uE710',
            AlertSolid: '\uF331',
            Attach: '\uE723',
            Calendar: '\uE787',
            Cancel: '\uE711',
            Chat: '\uE901',
            CheckMark: '\uE73E',
            ChevronDown: '\uE70D',
            ChevronLeft: '\uE76B',
            ChevronRight: '\uE76C',
            ChromeClose: '\uE8BB',
            CircleFill: '\uEA3B',
            CirclePlus: '\uEAEE',
            Clock: '\uE917',
            Comment: '\uE90A',
            CompassNW: '\uE942',
            CubeShape: '\uF1AA',
            Delete: '\uE74D',
            Diamond: '\uED02',
            DocumentSearch: '\uEF6C',
            Download: '\uE896',
            Edit: '\uE70F',
            EditSolid12: '\uF4B5',
            ExcelLogo: '\uF1E5',
            ExploreContent: '\uECCD',
            FabricFolder: '\uF0A9',
            FavoriteStar: '\uE734',
            Filter: '\uE71C',
            Flag: '\uE7C1',
            FluidLogo: '\uE48A',
            Forward: '\uE72A',
            Glimmer: '\uECF4',
            GridViewMedium: '\uF233',
            Group: '\uE902',
            Heart: '\uEB51',
            HeartFill: '\uEB52',
            Hide3: '\uF6AC',
            Home: '\uE80F',
            Link: '\uE71B',
            List: '\uEA37',
            Mail: '\uE715',
            More: '\uE712',
            MoreVertical: '\uF2BC',
            News: '\uE900',
            ODLink: '\uE4BB',
            OEM: '\uE74C',
            OfficeCatchUp: '\uE490',
            OneNoteLogo: '\uF1E7',
            OpenFile: '\uE8E5',
            OpenFolderHorizontal: '\uED25',
            OpenInNewTab: '\uF6AB',
            Page: '\uE7C3',
            People: '\uE716',
            PhotoVideoMedia: '\uF0B1',
            Pinned: '\uE840',
            PowerPointLogo: '\uF1EB',
            RedEye: '\uE7B3',
            Remove: '\uE738',
            Reply: '\uE97A',
            ReturnKey: '\uE751',
            Rocket: '\uF3B3',
            Share: '\uE72D',
            Sort: '\uE8CB',
            SortUp: '\uEE68',
            Stop: '\uE71A',
            Sync: '\uE895',
            Trending12: '\uF62D',
            TVMonitor: '\uE7F4',
            Unfavorite: '\uE8D9',
            Upload: '\uE898',
            Video: '\uE714',
            ViewAll: '\uE8A9',
            VisioLogo: '\uF2A7',
            WordLogo: '\uF1E3',
        },
    };
    registerIcons(subset);
}
//# sourceMappingURL=officestarticons.js.map